define(
({
  "load_error": "載入錯誤",
  "description": "要求未正確完成。請確保你的訂單已成功儲存並刷新此頁。"
})
);
